jQuery(function($) {
	$('.nav__btn').on('click',function(e){
		e.preventDefault();
		if ($('.header').hasClass("_open")) {
			$('.header').removeClass('_open');
		}else{
			$('.header').addClass('_open');
		};
	});

	$('.js-change-date').on('change', function(){
		const data = {
			ci : {
				indexY : document.getElementById('ciDateY').selectedIndex,
				indexM : document.getElementById('ciDateM').selectedIndex,
				indexD : ((document.getElementById('ciDateD').selectedIndex) +1)
			},
			co : {
				y : document.getElementById('coDateY'),
				m : document.getElementById('coDateM'),
				d : document.getElementById('coDateD')
			},
			month : {
				typeA   : [ 3 , 5 , 8 , 10],
				typeB   : [ 0 , 2 , 4 , 6 , 7 , 9 ,11],
				typeC   : 1
			}
		}
		let _indexY = data.ci.indexY;
		let _indexM = data.ci.indexM;
		let _indexD = data.ci.indexD;

		if(data.month.typeC == data.ci.indexM){
			let uru = ((data.ci.indexY + 1) % 4 == 0 && (data.ci.indexY + 1) % 100 != 0) || (data.ci.indexY + 1) % 400 == 0;
			if(uru == false && cid >= 28) {
				_indexM = data.ci.indexM + 1;
				_indexD = 0;
			} else if(uru == true && cid >= 29) {
				_indexM = data.ci.indexM + 1;
				_indexD = 0;
			}
		} else if(data.month.typeA.indexOf(data.ci.indexM) >= 0) {
			if(data.ci.indexD >= 30) {
				_indexM = data.ci.indexM + 1 ;
				_indexD = 0;
			}
		} else if(data.month.typeB.indexOf(data.ci.indexM) >= 0) {
			if(data.ci.indexD >= 31) {
				_indexM = data.ci.indexM + 1;
				_indexD = 0;
			}
		}

		if(_indexM == 12) {
			_indexY = data.ci.indexY + 1;
			_indexM = 0;
			_indexD = 0;
		}

		data.co.y.options[_indexY].selected = true;
		data.co.m.options[_indexM].selected = true;
		data.co.d.options[_indexD].selected = true;
	});


	/**
	 * スムーススクロール
	 */

	$('.js-scroll').on('click',function() {
		var speed = 400; // ミリ秒
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$('body,html').animate({scrollTop:position}, speed, 'swing');
		return false;
	});

	$(window).scroll(function (){
			$('.js-fade').each(function(){
					var POS = $(this).offset().top;  //fade-inがついている要素の位置
					var scroll = $(window).scrollTop();  //スクロール一
					var windowHeight = $(window).height();  //ウィンドウの高さ

					if (scroll > POS - windowHeight + windowHeight/5){
							$(this).css("opacity","1" );
					} else {
							$(this).css("opacity","0" );
					}
			});
	});

	$( '.slider' ).sliderPro({
		width: 1500,
		height: 540,
		visibleSize: '100%',
		forceSize: 'fullWidth',
		slideDistance: 0,
		//arrows: true,//左右の矢印
		fadeArrows: false
		//autoSlideSize: true
	 });

});
